import { combineReducers } from 'redux';
import allReducer from './AllReducer';

export default combineReducers({
  all: allReducer
});